<div class="why-inforida-container">
  <app-heading-small-component
    heading1="All you need to"
    heading2="elevate"
    heading3="your school's performance"
    description="Personalised solutions tailored to your school's digital demands"
    imageUrl="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/why-inforida-1.png"
  ></app-heading-small-component>
  <app-features-card class="features-card"></app-features-card>
  <app-cards-wrap class="cards-wrap">
    heading1="The" heading2="Four Pillars of" heading3="Inforida"
    heading4="Ecosystem" subheading="See how you can benefit →"
    [array]="fourPillars" ></app-cards-wrap
  >

  <app-how-we-do class="how-we-do"></app-how-we-do>

  <!-- <div class="digital-presence-container">
    <h2>
      Improve Your <br />
      <span>Digital Presence</span>
    </h2>
    <div class="digital-presence-wrapper">
      <div class="digital-presence-right-section">
        <h2>
          Improve Your <br />
          <span>Digital Presence</span>
        </h2>
        <p>
          Create A Government-Compliant Public Page To Showcase Your School's
          Facilities, Infracture, Achievements.
        </p>
        <p>With Real-Time Editing, Customisable Banners, And Vibrant Themes</p>
        <a>Learn how we can do it for you →</a>
      </div>
      <div class="digital-presence-left-section">
        <div class="digital-background"></div>
      </div>
    </div>
  </div> -->

  <app-we-do
    logo="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/quick-enroll-ai.png"
    heading="Improve Your"
    highlight="Digital Presence"
    [points]="description"
    [data]="quickEnrollPoints"
    imageLink="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/enroll-image.png"
    linkText="Learn how we can do it for you →"
    link="/products/QuickEnroll-AI"
    [isMorning]="false"
    class="app-we-do"
  ></app-we-do>

  <app-we-do
    logo="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/goood-morning-logo.png"
    heading="Fast Secure"
    highlight="Paperless Attendance"
    [points]="goodmorningDescription"
    [data]="attendancePoints"
    imageLink="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/attendance-main-image.png"
    linkText="Get Goood Morning for Your School →"
    link="/products/goood-morning"
    [isMorning]="true"
    class="app-we-do"
  ></app-we-do>

  <div class="benifits-container">
    <h1>
      Why you will
      <span
        >love <br />
        using</span
      >
      Inforida<span>.</span>
    </h1>
    <div class="benifits-wrapper">
      <div class="benifits-card" *ngFor="let card of benifits">
        <div
          class="benifits-icon"
          [style.background-color]="card.backgroundColor"
        >
          <mat-icon>{{ card.icon }}</mat-icon>
        </div>
        <div class="benifits-text">
          <h3>{{ card.title }}</h3>
          <p>{{ card.description }}</p>
        </div>
      </div>
    </div>
    <a><span>Sounds good?</span> Get to know more benifits →</a>
  </div>
</div>
